export default "/cyrillic-ext.2d06f2c3-476e2a.woff2";